module.exports = {"Administración de días no laborales":"Administración de días no laborales","Listado de días no laborales":"Listado de días no laborales","Ver día no laboral":"Ver día no laboral","Editar día no laboral":"Editar día no laboral","Nuevo día no laboral":"Nuevo día no laboral","Nombre":"Nombre","Fecha":"Fecha","¿Repite anualmente?":"¿Repite anualmente?","Listado de feriados":"Listado de feriados"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/feriados/es.json
// module id = 1349
// module chunks = 0